module.exports = __webpack_public_path__ + "img/praying-hands-prayer-religion-clip-art-png-favpng-miFJpNdn2M66SL0kHAXP8YC7Q.bbe7495f.jpg";